if (typeof FeaturedCollection === 'undefined') {
  class FeaturedCollection extends HTMLElement {
    constructor() {
      super();

      this.container = this.querySelector('.js-featured-collection');
      this.items = this.container.childNodes;
      this.current = 0;

      this.prevButton = this.querySelector('button[name="previous"]');
      this.nextButton = this.querySelector('button[name="next"]');

      if (!this.nextButton) return;

      this.prevButton.addEventListener('click', this.movePrev.bind(this));
      this.nextButton.addEventListener('click', this.moveNext.bind(this));
    }

    moveNext(event) {
      event.preventDefault();

      this.current++;
      this.moveCarouselTo();
    }

    movePrev(event) {
      event.preventDefault();

      this.current--;
      this.moveCarouselTo();
    }

    moveCarouselTo() {
      if(this.current === 0) {
        this.prevButton.classList.remove('md:flex');
      } else {
        this.prevButton.classList.add('md:flex');
      }

      if(this.current === this.items.length - 3) {
        this.nextButton.classList.remove('md:flex');
      } else {
        this.nextButton.classList.add('md:flex');
      }

      const translateVal = this.current * 100;
      this.items.forEach((item, index) => {
        item.style.cssText = `transform: translateX(-${translateVal}%)`;
      })
    }
  }

  if(customElements.get('featured-collection') === undefined) {
    customElements.define('featured-collection', FeaturedCollection);
  }
}